<template>
	<div
		class="home-video">
		<div
			ref="jarallax"
			class="jarallax"
			:style="{ backgroundImage: `url('${video}')` }"
			:data-jarallax-video="video"></div>
	</div>
</template>

<script>
import { jarallax, jarallaxVideo } from 'jarallax';

function mounted() {
	jarallaxVideo();
	jarallax(this.$refs.jarallax, {
		speed: 0.2,
	});
}

function beforeDestroy() {
	jarallax(document.querySelectorAll('.jarallax'), 'destroy');
}

export default {
	name: 'media',
	beforeDestroy,
	mounted,
	props: ['video'],
};
</script>

<style lang="scss" scoped>
.home-video {
	.jarallax {
		min-height: 400px;
	}
}

@media screen and (max-width: 600px) {
	.home-video {
		.jarallax {
			min-height: 200px;
		}
	}
}
</style>




// WEBPACK FOOTER //
// src/components/home/media.vue